import React, {useEffect, useState} from 'react'
import styles from './EventGuestInformation.module.css'
import {useParams} from "react-router";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import download from 'downloadjs';

import {
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel, ListItemText, MenuItem, OutlinedInput,
    Select,
    SelectChangeEvent
} from "@mui/material";
import {useAutoEvt} from "../../queries/useAutoEvt";
import Button from "@mui/material/Button";
import axios from "axios";
import { useForm } from 'react-hook-form'
import HookForm from "../../components/common/HookForm";
import {Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

interface Params {
  eventid: string
}

interface FormData {
    ticketid: number
    includepurchasername: number,
    includeuserfields: number,
    includesystemfields: number,
}
const EventGuestInformation = () => {
    const { eventid } = useParams<Params>()
    useAutoEvt(eventid)
    const guestInfoFormMethods = useForm<FormData>()
    const { setValue, watch, getValues, setError, clearErrors, setFocus, reset } = guestInfoFormMethods
    const [ticketSelection, setTicketSelection] = React.useState<string[]>([]);
    const [loading, setLoading] = React.useState(false)
    const [includepurchasername, setincludepurchasername] = React.useState(true)
    const [includeuserfields, setincludeuserfields] = React.useState(true)
    const [includesystemfields, setincludesystemfields] = React.useState(true)
    const [ticketItem, setTicketItem] = useState(0)
    const [guestData, setGuestData] = React.useState({selectedticketid: null, ticketlist: []})
    const [dialogMsg, setDialogMsg] = React.useState("");

    const getData = async () => {
        setLoading(true)
        var body = {'eventid': eventid}
        const { data } = await axios.post('/evtguestinformation', body)
        const parsedData = JSON.parse(data.jsonString)

        console.log(parsedData)
        setGuestData(parsedData)
        if (parsedData?.ticketlist?.length > 0) {
            setTicketSelection(parsedData?.ticketlist?.map(item => {
                return item.ticketname
            }))
            const ticketItem = parsedData?.ticketlist[0]
            setTicketItem(ticketItem.ticketid)
        }

        setLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])


    const handleSelectionChange = async (event: SelectChangeEvent) => {
        setTicketItem(Number(event.target.value))
    }

    const getTicketItemOptions = () => {
        return guestData?.ticketlist?.map(item => (
            <MenuItem key={item.ticketid} value={item.name}>
                <Checkbox color="primary" checked={ticketSelection.indexOf(item.ticketname) > -1} />
                <ListItemText primary={item.ticketname} />
            </MenuItem>
        ))
        return []
    }

    const onSubmit = (data: FormData) => {
        setLoading(true)

        var ticketsToSave = []
        guestData?.ticketlist?.forEach(tag => {
            if (ticketSelection.find((item) => item === tag.ticketname)) {
                ticketsToSave.push(tag.ticketid)
            }
        })
        if (ticketsToSave && ticketsToSave.length <= 0) {
            setDialogMsg('Please select at least one ticket type.')
            setLoading(false)
        }
        else {
            const commaSeparatedString = ticketsToSave.join(',');

            const body = {
                includepurchasername: includepurchasername,
                includeuserfields: includeuserfields,
                includesystemfields: includesystemfields,
                ticketid: commaSeparatedString,
                type: 'exportexcel',
                eventid: eventid,
            }

            axios.post('/evtguestinformationprocess', body, {responseType: "blob"}).then(response => {
                var filename = eventid + '-guestinformation.xlsx';
                var disposition = response.headers['content-disposition']
                var contentType = response.headers['content-type']
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }
                if (response.data) {
                    download(response.data, filename, contentType);
                }
                setLoading(false)
            })
        }

    }

    const handleincludepurchasername = (event) => {
        setincludepurchasername(event.target.checked);
    }

    const handleincludeuserfields = (event) => {
        setincludeuserfields(event.target.checked);
    }

    const handleincludesystemfields = (event) => {
        setincludesystemfields(event.target.checked);
    }

    const handleTicketChange = (event: SelectChangeEvent<typeof ticketSelection>) => {
        const {
            target: { value },
        } = event;

        var values = []
        if (typeof value === 'string') {
            values = [value]
        }
        else {
            value?.forEach(v => {
                if (v.length > 0) {
                    values.push(v)
                }
            })
        }

        setTicketSelection(values)
    }

    const closeDialog = () => {
        setDialogMsg("")
    }

    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loading} />
            <h1>Guest Information</h1>
            <HookForm
                methods={guestInfoFormMethods}
                onSubmit={onSubmit}
                className={styles.guestinfoForm}
                formProps={{ id: 'guestinfo-form' }}>
                <>
                    <Dialog
                        open={dialogMsg.length > 0}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {dialogMsg}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={closeDialog}>Ok</Button>
                        </DialogActions>
                    </Dialog>
                </>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-begin"
                    alignItems="center"
                    // border={2}
                    spacing={2}
                    style={{marginBottom: '20px'}}
                    xs={12} sm={12} md={12}
                >
                    <Grid item xs={6}>
                        <FormControl style={{width: '100%'}}>
                            <InputLabel style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}}>Ticket Type</InputLabel>

                            {/*<InputLabel  style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}} >*/}
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                name="ticketid"
                                value={ticketSelection}
                                onChange={handleTicketChange}
                                multiple
                                input={<OutlinedInput label="Ticket Type" />}
                                // input={<OutlinedInput label="Enter a Ticket" />}
                                renderValue={(selected) => selected.join(', ')}
                                MenuProps={MenuProps}
                                style={{ width: '100%' }}>
                                {
                                    guestData?.ticketlist?.map(item => (
                                        <MenuItem key={item.ticketid} value={item.ticketname}>
                                        <Checkbox color="primary" checked={ticketSelection.indexOf(item.ticketname) > -1} />
                                        <ListItemText primary={item.ticketname} />
                                        </MenuItem>
                                    ))
                                }
                            </Select>

                        {/*</InputLabel>*/}
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel control={
                            <Checkbox
                                name={'includepurchasername'}
                                checked={includepurchasername}
                                onChange={handleincludepurchasername}
                                defaultChecked />
                        } label="Include Purchaser Name" />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel control={
                            <Checkbox
                                name={'includeuserfields'}
                                checked={includeuserfields}
                                onChange={handleincludeuserfields}
                                defaultChecked
                            />
                        } label="Include User Defined Fields" />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel control={
                            <Checkbox
                                name={'includesystemfields'}
                                checked={includesystemfields}
                                onChange={handleincludesystemfields}
                                defaultChecked
                            />
                        } label="Include System Fields" />
                    </Grid>
                    <Grid item xs={4}>
                        <Button type="submit" color="primary" variant="contained" form="guestinfo-form" className={styles.button}>
                            EXPORT TO EXCEL
                        </Button>
                    </Grid>
                    <Grid item xs={8}>
                    </Grid>
                </Grid>
            </HookForm>
        </div>
    )
}

export default EventGuestInformation
